import styled from 'styled-components';

export const PriceEditableStyled = styled.div`
    display: flex;
    flex-direction: row;
    gap: 24px;
    align-items: center;
    font-size: 16px;

    .editable {
        display: inline;
        color: #FFFFFF;
        font-weight: 700;

        &:focus {
            outline: none;
        }
    }
`;

export const PriceEditableButtonsStyled = styled.div`
    display: flex;
    flex-direction: row;
    gap: 8px;

    svg {
        fill: #FFFFFF;
    }

    > * {
        text-align: center;
        flex: 1;
        background: rgba(129, 146, 228, 0.1);
        border-radius: 12px;
        padding: 12px;
        cursor: default;
    }
`;
